import { AiReportApi } from "@/api";

export async function get(businessPlanId) {
  try {
    const { data } = await AiReportApi.get(businessPlanId);
    return data;
  } catch (ex) {
    if (ex.response?.status === 404) {
      console.warn("Report non trovati per business plan", businessPlanId);
      return [];
    } else {
      console.error("Errore nel recupero dei report:", ex);
      throw ex;
    }
  }
}

export async function generate(businessPlanId) {
  try {
    const { data } = await AiReportApi.generate(businessPlanId);
    return data;
  } catch (ex) {
    console.error("Errore nella generazione del report:", ex);
    throw ex;
  }
}

export async function download(reportId) {
  try {
    const { data } = await AiReportApi.download(reportId);
    return data;
  } catch (ex) {
    console.error("Errore nel recupero del link di download:", ex);
    throw ex;
  }
}
